"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var jquery_1 = __importDefault(require("jquery"));
function createImageChooser(id) {
    var chooserElement = jquery_1["default"]('#' + id + '-chooser');
    var previewImage = chooserElement.find('.preview-image img');
    var input = jquery_1["default"]('#' + id);
    var editLink = chooserElement.find('.edit-link');
    var chooserBaseUrl = chooserElement.data('chooserUrl');
    /*
    Construct initial state of the chooser from the rendered (static) HTML and arguments passed to
    createImageChooser. State is either null (= no image chosen) or a dict of id, edit_link,
    title and preview (= a dict of url, width, height).
  
    The result returned from the image chooser modal (see get_image_result_data in
    wagtail.images.views.chooser) is a superset of this, and can therefore be passed directly to
    chooser.setState.
    */
    var state = null;
    if (input.val()) {
        state = {
            id: input.val(),
            edit_link: editLink.attr('href'),
            title: previewImage.attr('alt'),
            preview: {
                url: previewImage.attr('src'),
                width: previewImage.attr('width'),
                height: previewImage.attr('height'),
            }
        };
    }
    /* define public API functions for the chooser */
    var chooser = {
        getState: function () { return state; },
        getValue: function () { return state && state.id; },
        setState: function (newState) {
            if (newState) {
                input.val(newState.id);
                previewImage.attr({
                    src: newState.preview.url,
                    width: newState.preview.width,
                    height: newState.preview.height,
                    alt: newState.title,
                    title: newState.title
                });
                chooserElement.removeClass('blank');
                editLink.attr('href', newState.edit_link);
            }
            else {
                input.val('');
                chooserElement.addClass('blank');
            }
            state = newState;
        },
        getTextLabel: function (opts) {
            if (!state)
                return null;
            var result = state.title;
            if (opts && opts.maxLength && result.length > opts.maxLength) {
                return result.substring(0, opts.maxLength - 1) + '…';
            }
            return result;
        },
        focus: function () {
            jquery_1["default"]('.action-choose', chooserElement).focus();
        },
        openChooserModal: function () {
            // eslint-disable-next-line no-undef, new-cap
            ModalWorkflow({
                url: chooserBaseUrl,
                // eslint-disable-next-line no-undef
                onload: IMAGE_CHOOSER_MODAL_ONLOAD_HANDLERS,
                responses: {
                    imageChosen: function (result) {
                        chooser.setState(result);
                    },
                },
            });
        },
        clear: function () {
            chooser.setState(null);
        }
    };
    /* hook up chooser API to the buttons */
    jquery_1["default"]('.action-choose', chooserElement).on('click', function () {
        chooser.openChooserModal();
    });
    jquery_1["default"]('.action-clear', chooserElement).on('click', function () {
        chooser.clear();
    });
    return chooser;
}
window.createImageChooser = createImageChooser;
